export * from './IconCamera';
export { default as IconCamera } from './IconCamera';
